import {useEffect} from 'react';

import getErrorMessage from '~utils/getErrorMessage';
import {showError} from '~utils/toast';

export default function useShowError(error?: Error) {
    useEffect(() => {
        if (error) {
            showError(getErrorMessage(error.message));
        }
    }, [error]);
}
